import React, { useCallback } from 'react';
import { useParams } from 'react-router';
import { useI18n } from '../../../data/hooks/i18nHooks';
import { useMyAccount } from '../../../data/hooks/sessionHooks';
import ButtonLink from '../../elements/ButtonLink';
import { dialogAlert } from '../../elements/Dialog/dialogs';
import Scrollable from '../../elements/Scrollable';
import Screen from '../Screen';
import AddEventWithCodeHeader from './AddEventWithCodeHeader/AddEventWithCodeHeader';
import AddEventWithCodeToAccountDescription from './AddEventWithCodeToAccountDescription/AddEventWithCodeToAccountDescription';
import AddEventWithCodeTopBar from './AddEventWithCodeTopBar/AddEventWithCodeTopBar';
import AddWithCodeErrorFlow from './AddWithCodeErrorFlow/AddWithCodeErrorFlow';
import AddWithCodeLoginRequiredFlow from './AddWithCodeLoginRequiredFlow/AddWithCodeLoginRequiredFlow';
import { useCodeVerification } from './useCodeVerification';

/**
 * Add event with code already known and passed in the URL or from localstorage
 */
export function AddEventWithCode(props) {
    const {} = props,
        i18n = useI18n(),
        {code} = useParams(),
        [summary, error] = useCodeVerification(code),
        user = useMyAccount();

    // handle submit
    const handleSubmit = useCallback(
        async e => {
            e.preventDefault();
            app.store.dispatch(app.actions.ui.busy());
            try {
                const answer = await app.api.events.addEvent(code);
                app.store.dispatch(app.actions.session.clearPrefill());
                app.history.push('/events/' + answer.event_id);
            } catch (error) {
                if (error.response && error.response.status >= 400 && error.response.status <= 499) {
                    await dialogAlert(i18n['error.not.valid.event.code']);
                } else {
                    console.error(error);
                }
            }
            app.store.dispatch(app.actions.ui.free());
        },
        [i18n, code]
    );

    const header = <AddEventWithCodeTopBar event={summary} />;

    return (
        <Screen header={header}>
            <Scrollable>
                <AddEventWithCodeHeader event={summary} />

                <form onSubmit={handleSubmit}>
                    <div className="content">
                        <AddWithCodeErrorFlow user={user} error={error} />
                        <AddWithCodeLoginRequiredFlow user={user} event={summary} />
                        <br />
                        {summary && user && (
                            <ButtonLink type="submit" className="primaryaction">
                                {i18n['label.go.eventcode']}
                            </ButtonLink>
                        )}

                        <AddEventWithCodeToAccountDescription event={summary} user={user} />
                    </div>
                </form>
            </Scrollable>
        </Screen>
    );
}

export default AddEventWithCode;
